import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';
import MarketSnapshotsPage from 'lumen/components/market/snapshots/page';
import MarketSnapshotsTableLayout from 'lumen/components/market/snapshots/table-layout';
import type MarketSnapshotsPickupController from 'lumen/controllers/market/snapshots/pickup';
import type MarketSnapshotsPickupRoute from 'lumen/routes/market/snapshots/pickup';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSnapshotsPickupSignature {
  Args: {
    controller: MarketSnapshotsPickupController;
    model: ModelFrom<MarketSnapshotsPickupRoute>;
  };
}

<template>
  <MarketSnapshotsPage
    @dates={{@controller.dates}}
    @kpiSection={{@controller.kpiSection}}
    @pagination={{@controller.pagination}}
    @table={{@controller.table}}
    @title={{t "market.snapshots.view.pickup"}}
    @view="pickup"
  >
    <:tableControls>
      <MarketSnapshotsTableLayout
        @hideSortOn={{not @controller.config.isSortable}}
        @hideVariance={{not @controller.config.hasVariance}}
        @manageColumns={{hash
          fixed=@controller.config.columns.fixed
          kpiSettings=@controller.kpiColumnSettings
          metrics=@controller.columnMetrics
          settings=@controller.columnSettings
        }}
        @onSave={{@controller.updateTableLayoutPreferences}}
        @tableLayoutPreferences={{@controller.tableLayoutPreferences}}
      />
    </:tableControls>
  </MarketSnapshotsPage>
</template> satisfies TOC<MarketSnapshotsPickupSignature>;
